<div class="bg-white rounded-lg p-3 sm:p-6 w-full">
    <div class="flex flex-row justify-between items-center">
        <h2 class="text-2xl font-semibold mb-4 leading-none tracking-tight">
            {{ isCreatingApplication() ? 'Criando Aplicação' : applicationForm.controls.name.value }}
        </h2>

        <button mat-icon-button (click)="onCancelClick()" matTooltip="fechar">
            <mat-icon svgIcon="heroicons_outline:x-circle" class="icon-size-6"></mat-icon>
        </button>
    </div>
    <p class="text-gray-600 mb-6">
        Configure informações da aplicação
    </p>

    <div [formGroup]="applicationForm">
        <div>
            <h3 class="text-lg font-medium mb-4">Básicas</h3>

            <mat-form-field class="w-full mb-3" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name"/>
                <mat-error ngx-mat-errors></mat-error>
            </mat-form-field>

            <mat-form-field class="w-full mb-3" appearance="outline">
                <mat-label>URI de Redirecionamento</mat-label>
                <input matInput formControlName="redirectUri"/>
                <mat-error ngx-mat-errors></mat-error>
            </mat-form-field>

            <mat-form-field class="w-full mb-3" appearance="outline">
                <mat-label>URI de Edição do Usuário</mat-label>
                <input matInput formControlName="userEditUri"/>
                <mat-error ngx-mat-errors></mat-error>
            </mat-form-field>

            <mat-form-field class="w-full mb-3" appearance="outline">
                <mat-label>Chave Secreta</mat-label>
                <input matInput formControlName="secretKey"/>
                
                <button mat-icon-button matSuffix (click)="onGenerateSecretKeyClick()" matTooltip="Gerar nova chave secreta">
                    <mat-icon svgIcon="heroicons_outline:key" class="icon-size-6"></mat-icon>
                </button>

                <mat-error ngx-mat-errors></mat-error>
            </mat-form-field>

            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Modo de Autenticação</mat-label>
                <mat-select formControlName="authMode">
                    @for (mode of authModes; track mode) {
                        <mat-option [value]="mode">{{mode}}</mat-option>
                    }
                </mat-select>
                <mat-error ngx-mat-errors></mat-error>
            </mat-form-field>
        </div>

        <div>
            <h3 class="text-lg font-medium mb-4">Webhook</h3>

            <mat-checkbox 
                formControlName="webhookEnabled" 
                class="mb-4"
                (change)="onWebhookEnabledChange($event)">
                Habilitar Webhook
            </mat-checkbox>

            @if (applicationForm.get('webhookEnabled').value) {
                <mat-form-field class="w-full mb-3" appearance="outline">
                    <mat-label>URL do Webhook</mat-label>
                    <input matInput formControlName="webhookUrl"/>
                    <mat-error ngx-mat-errors></mat-error>
                </mat-form-field>

                @if (!isCreatingApplication()) {
                    <mat-form-field class="w-full mb-3" appearance="outline">
                        <mat-label>Webhook Chave Secreta</mat-label>
                        <input matInput formControlName="webhookSecret"/>
                        
                        <button mat-icon-button 
                                matSuffix 
                                (click)="onGenerateWebhookSecretClick()" 
                                matTooltip="Gerar nova chave secreta">
                            <mat-icon svgIcon="heroicons_outline:key" class="icon-size-6"></mat-icon>
                        </button>

                        <mat-error ngx-mat-errors></mat-error>
                    </mat-form-field>
                }
            }

            @if (showWebhookSecret()) {
                <fuse-alert
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert().type">
                    {{alert().message}}
                </fuse-alert>
            }
        </div>        

        <div class="flex flex-row justify-between space-x-1 mt-4">
            <!-- Cancel button -->
            <button mat-stroked-button color="accent" (click)="onCancelClick()">
                Cancelar
            </button>

            <!-- Save button -->
            <button mat-raised-button 
                    color="primary" 
                    (click)="onSubmitClick()" 
                    [disabled]="applicationForm.invalid">
                {{ isCreatingApplication() ? 'Criar' : 'Salvar' }}
            </button>
        </div>
    </div>
</div> 